import { render } from "./StoryItem.vue?vue&type=template&id=d77a69b6"
import script from "./StoryItem.vue?vue&type=script&lang=js"
export * from "./StoryItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__